import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials sends the httpOnly `admin_token` cookie on every request.
// Admin auth is cookie-based; no tokens live in localStorage.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_6aa50ac6-6491-4cdd-ae40-783d99c83368/artifacts/z2pljbsu_FB_IMG_1780170011870.jpg";
